<template>
  <div>
    <el-form :model="formData" :rules="rules" ref="form" class="main-form-scroll">
      <el-form-item :label="$t('param.paramType')" prop="typeSelected">
        <el-select v-model="formData.typeSelected" filterable :placeholder="$t('param.paramTypeNotSelected')">
          <el-option
            v-for="param in getTypeParam"
            :key="param.id"
            :value="param.id"
            :label="param.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('param.value')" prop="valueSelected">
        <el-input v-model="formData.valueSelected"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{ $t('param.cancel') }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick">OK</el-button>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  props: {
    type: String,
  },
  data() {
    return {
      formData: {
        typeSelected: null,
        valueSelected: null,
      },
      rules: {
        typeSelected: [
          {
            required: true,
            message: this.$t('param.enterParamType'),
            trigger: "change",
          },
        ],
        valueSelected: [
          {
            required: true,
            message: this.$t('param.enterParamValue'),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    populateForm() {
      this.formData.typeSelected = this.getCurInfo.idParam;
      this.formData.valueSelected = this.getCurInfo.value;
    },
    okClick() {
      for (let index in this.formData) {
        if (
          this.formData[index] != null &&
          typeof this.formData[index] === "string"
        ) {
          this.formData[index] = this.formData[index].trim();
        }
      }
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t('errors.notAllRequiredFieldsSelected'));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getTypeParam", "getCurInfo", "getParents"]),
  },
  created() {
    if (this.type === "add") {
      this.$store.commit("setLoading", true);
      //достаем те параметры для добавления, которые в приложении еще не использованы
      this.$store
        .dispatch("getSectionParamType", this.getParents[1])
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    } else if (this.type === "edit") {
      this.$store.commit("setLoading", true);
      //достаем все параметры, иначе конкретно наших там не будет -- они уже использованы
      this.$store
        .dispatch("getSectionAllParamType")
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
      this.populateForm();
    }
  },
};
</script>

